import Vue from 'vue';

export default function() {
	Vue.$ofsCrud.addResource({
		name: 'product',
		pluralName: 'products',
		transport: 'davinci',
		options: {
			namespaced: true
		}
	});
}
